export default __webpack_public_path__ + "static/media/uber.245f3424.webp";